import _ActivityFeedQuery from "../__generated__/ActivityFeedQuery.graphql";
import { graphql, useLazyLoadQuery } from 'react-relay';
import { patternLabel } from './practice.ts';
import { formatDate } from '../i18n/format';
import { t } from '../i18n/t';
import { statusLabel } from './progress';
import type { ActivityFeedQuery } from '../__generated__/ActivityFeedQuery.graphql';
export function ActivityFeed({
  itemId
}: {
  itemId: string;
}) {
  const data = useLazyLoadQuery<ActivityFeedQuery>((_ActivityFeedQuery.hash && _ActivityFeedQuery.hash !== "d7012d8baec7616891291c325ff2cd00" && console.error("The definition of 'ActivityFeedQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _ActivityFeedQuery), {
    itemId
  });
  const sessions = data?.me?.learner?.sessions?.nodes ?? [];
  const filtered = sessions.filter(s => s.practice.some(p => p.item.id === itemId));
  const items = [...filtered].sort((a, b) => Date.parse(b.startedAt) - Date.parse(a.startedAt));
  if (items.length === 0) {
    return <p className="text-base-content/50 text-center py-6">{t('activity-empty')}</p>;
  }
  return <section className="flex flex-col gap-2 mt-4">
      <h2 className="font-semibold">{t('activity-title')}</h2>
      {items.map(session => {
      const outcome = session.practice.find(p => p.item.id === itemId);
      if (!outcome) return null;
      const label = statusLabel(outcome.outcome) ?? outcome.outcome;
      const colour: Record<string, string> = {
        RECURRED: 'badge-error',
        TARGETED: 'badge-warning',
        USED_CORRECTLY: 'badge-success'
      };
      return <div key={session.id} className="flex items-center justify-between gap-2">
            <span className="font-medium text-sm">{patternLabel(outcome.item.pattern)}</span>
            <div className="flex items-center gap-2">
              <span className={`badge badge-sm ${colour[outcome.outcome] ?? 'badge-ghost'}`}>{label}</span>
              <span className="text-xs text-base-content/50">{formatDate(new Date(session.startedAt))}</span>
            </div>
          </div>;
    })}
    </section>;
}